<template>
	<div id="PublicFooter">
		<div class="layout-footer">
			<div class="footer-row">
				<ul class="pc-row">
					<!-- <li class="pc-row-me">
						<a target="_blank" href="/auth/we"></a>
					</li> -->
					<!-- <li class="pc-row-com">
						<p>版权所有：山西华彩传媒有限公司</p>
					</li> -->
					<li class="pc-row-privacy">
						<a target="_blank" href="/#/fahuo">發貨須知</a>
					</li>
					<li class="pc-row-privacy">
						<a target="_blank" href="/#/privacy">隱私協議</a>
                       
					</li>

					<li class="pc-row-agreement">
						<a target="_blank" href="/#/UserAgreement">用戶協議</a>
					</li>
				</ul>
			</div>
			<!-- <div class="footer-row">
				<ul class="pc-row">
					<li class="pc-row-icp">
						<a target="_blank" href="https://beian.miit.gov.cn/">ICP备案号：晋ICP备2022007261号-1</a> 
					</li>
					<li class="pc-row-ga">
						<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo"><img src="@/assets/images/PublicFooter/beian.png" alt="">晋公网安备 14118102000160号</a>
					</li>
				</ul>
			</div> -->

			<div class="footer-row2">
				<!-- <img src="@/assets/images/public/footer.png" alt=""> -->
				<!-- <img style="margin-left: 20px;" src="@/assets/images/PublicFooter/RZ.png" alt=""> -->
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'PublicFooter',
	data() {
		return {
		}
	},

	created() {
	},

	methods: {
		Toxx(val) {
			this.$router.push(val)
		},
	}
}
</script>

<style lang="scss" scoped>
#PublicFooter {
	box-sizing: border-box;

	.layout-footer {
		width: 100%;
		background: #100b19;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		padding: 42px 0;
		position: relative;

		.footer-row {
			margin-bottom: 22px;
			.pc-row {
				display: flex;
				justify-content: center;
				align-items: center;

				.pc-row-me {
					padding: 0 10px;
					border-right: 1px solid #49597a;

					a {
						font-size: 18px;
						color: #49597a;
						cursor: pointer;
						line-height: 1;

						&:hover {
							color: #fff;
						}
					}
				}

				.pc-row-com {
					padding: 0 10px;
					border-right: 1px solid #49597a;

					p {
						line-height: 1;
						font-size: 18px;
						color: #49597a;
					}
				}

				.pc-row-privacy {
					padding: 0 10px;
					border-right: 1px solid #49597a;

					a {
						font-size: 18px;
						color: #49597a;
						cursor: pointer;
						line-height: 1;

						&:hover {
							color: #fff;
						}
					}
				}

				.pc-row-agreement {
					padding: 0 10px;
					a {
						font-size: 18px;
						color: #49597a;
						cursor: pointer;
						line-height: 1;
						&:hover {
							color: #fff;
						}
					}
				}

				.pc-row-icp{
					padding: 0 10px;
					border-right: 1px solid #49597a;
					a {
						text-decoration: none;
						font-size: 18px;
						color: #49597a;
						cursor: pointer;
						line-height: 1;
						&:hover {
							color: #fff;
						}
					}
				}
				.pc-row-ga{
					padding: 0 10px;
					a {
						text-decoration: none;
						font-size: 18px;
						color: #49597a;
						cursor: pointer;
						line-height: 1;
						img{
							width:18px;
							height:18px;
						}
						&:hover {
							color: #fff;
						}
					}
				}
			}
		}
		.footer-row2{
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

}</style>
